module.exports = function() {
  return new Worker(__webpack_public_path__ + "54a5a479326da7fe068c.worker.js");
};